module.exports = __webpack_public_path__ + "img/ic-shevron-in-circle.f71a3646.svg";